/* eslint-disable comma-dangle, prefer-regex-literals */

const Typograf = require('typograf')
const customRules = require('./customTypografRules')

customRules.forEach(rule => {
  Typograf.addRule(rule)
})

const typograf = new Typograf({
  locale: ['ru', 'en-US'],
  disableRule: [
    'common/html/*',
    'common/number/*',
    'common/other/*',
    'common/punctuation/*',
    'common/symbols/*',
    'common/space/afterPunctuation',
    'ru/dash/*',
    'ru/date/*',
    'ru/money/*',
    'ru/optalign/*',
    'ru/other/*',
    'ru/punctuation/*',
    'ru/symbols/*',
    'ru/typo/*',
    'common/space/*',
    'ru/nbsp/groupNumbers',
    'common/nbsp/afterShortWord',
  ],
  enableRule: [
    'ru/nbsp/shorties',
    'ru/nbsp/because',
    'ru/nbsp/mdash',
    'common/nbsp/shorties',
    'ru/dash/main',
    'common/other/nonbreakingHyphens',
    'common/other/nonbreakingThinSpace',
    'ru/nbsp/beforeParticles',
    'ru/nbsp/afterNumber',
  ],
})

typograf.addSafeTag('<nohyphen>', '</nohyphen>')
typograf.addSafeTag('<widget>', '</widget>')

module.exports = typograf
